import React, { PropsWithChildren } from 'react';
import Text from '../Text';

interface HelperTextProps extends PropsWithChildren {
  error?: boolean;
}

const HelperText: React.FC<HelperTextProps> = ({ error, children }) => {
  return (
    <Text typo="body4" color={error ? 'red50' : 'gray50'}>
      {children}
    </Text>
  );
};

export default HelperText;
